module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/schleiferei.json
// module id = 257
// module chunks = 261001525662246